/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import * as api from '@/api/secret';
import { SECRET } from '@/store/types';

export interface StoreSecretSearchTipState {
  kw: string;
  result: string[];
  loaded: boolean;
  filter: string;
}

export default {
  namespaced: true,
  state: {
    kw: '',
    result: [],
    loaded: false,
    filter: '',
  },
  getters: {},
  actions: {
    [SECRET.SEARCH_TIP_REQUEST]({ commit, state }, params) {
      params.kw = params.kw || '';
      if (!state.loaded || state.kw !== params.kw || state.filter !== params.filter) {
        params.reload = true;
      }
      if (params.reload) {
        commit(SECRET.SEARCH_TIP_REQUEST, params);
        return new Promise((resolve, reject) => {
          api.getSearchTips({ filter: params.filter, q: params.kw }).then((res) => {
            commit(SECRET.SEARCH_TIP_SUCCESS, {
              filter: params.filter,
              kw: params.kw,
              result: res.data,
            });
            resolve();
          }).catch(reject);
        });
      }
      return Promise.resolve();
    },
  },
  mutations: {
    [SECRET.SEARCH_TIP_REQUEST](state, { kw, filter }) {
      // 防止搜索时候下拉闪烁 如果都是%结束 暂时不清除结果
      if (kw.substr(-1) !== '%' || state.kw.substr(-1) !== '%') {
        state.result = [];
      }
      state.kw = kw;
      state.filter = filter;
    },
    [SECRET.SEARCH_TIP_SUCCESS](state, { kw, result }) {
      if (state.kw !== kw) {
        return;
      }
      state.loaded = true;
      state.result = result || [];
    },
  },
};
